import { AuctionStatus } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'
import { Helmet } from 'react-helmet'

import { MinterAuctionsProvider } from '../../Contexts'
import { PlayToolbar } from '../../Toolbar'
import WorldBasePage from '../WorldBasePage'
import GridMap from './GridMap'

const PlayPage: React.FC = () => {
  console.log('Creating PlayPage')

  return (
    <MinterAuctionsProvider defaultFilter={AuctionStatus.Minted}>
      <WorldBasePage toolbar={<PlayToolbar />} hideFooter>
        <Helmet title="Play" />
        <GridMap flexGrow={1} />
      </WorldBasePage>
    </MinterAuctionsProvider>
  )
}

export default PlayPage
